export default "__VITE_ASSET__0b936083__"